export const formatterHNL = new Intl.NumberFormat("es-HN", {
  style: "currency",
  currency: "HNL",
  minimumFractionDigits: 2,
  currencySign: "accounting",
});

export const formatterUSD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

export const CURRENCY = "L.";

export const formatCurrency = (value) => {
  if (typeof value === "string") {
    value = parseFloat(value);
  }
  const formatedValue = value || 0;
  return `${CURRENCY} ${formatedValue
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
};

export const getCheckout = () => {
  let checkout = localStorage.getItem("checkout") || null;
  if (checkout) {
    checkout = JSON.parse(checkout);
  } else {
    checkout = {};
  }
  return checkout;
};

export const lsCartToArray = () => {
  let cart = localStorage.getItem("cart") || null;
  let cartArray = [];
  let finalArray = [];
  if (cart) {
    cartArray = cart.split("}");
    cartArray.map((d, key) => {
      if (key > 0 && d !== "") {
        d = d.substr(1);
      }
      if (d !== "") {
        finalArray.push(JSON.parse(d + "}"));
      }
      return null;
    });
  }
  return finalArray;
};
export const getSubtotalFromCart = (cart, currency, valueUSD) => {
  let subtotal = 0;
  if (currency === "USD") {
    cart.constructor === Array &&
      cart.map((item) => {
        return (subtotal =
          (Math.ceil(item.price / valueUSD) - 0.01) * item.quantity + subtotal);
      });
  } else {
    cart.constructor === Array &&
      cart.map((item) => {
        return (subtotal = Math.ceil(item.price) * item.quantity + subtotal);
      });
  }
  return subtotal;
};
export const getCustomizationCostValue = (value, currency, valueUSD) => {
  if (currency === "USD") {
    return value / valueUSD;
  } else {
    return value;
  }
};
export const validateDiscount = (discount) => {
  if (discount < 0 || discount > 1) {
    return false;
  } else {
    return true;
  }
};
export const getDepartmentsFromId = (id) => {
  switch (id) {
    case 1:
      return "Atlántida";
    case 2:
      return "Choluteca";
    case 3:
      return "Colón";
    case 4:
      return "Comayagua";
    case 5:
      return "Copán";
    case 6:
      return "Cortés";
    case 7:
      return "El Paraíso";
    case 8:
      return "Francisco Morazán";
    case 9:
      return "Gracias a Dios";
    case 10:
      return "Intibucá";
    case 11:
      return "Islas de la Bahía";
    case 12:
      return "La Paz";
    case 13:
      return "Lempira";
    case 14:
      return "Ocotepeque";
    case 15:
      return "Olancho";
    case 16:
      return "Santa Bárbara";
    case 17:
      return "Valle";
    case 18:
      return "Yoro";
    default:
      return "";
  }
};
